import { render, staticRenderFns } from "./wrap.vue?vue&type=template&id=18bf2206&scoped=true"
var script = {}
import style0 from "./wrap.vue?vue&type=style&index=0&id=18bf2206&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bf2206",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonCustomImage: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/common/custom-image.vue').default,TopAreaMap: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/top/area-map/index.vue').default,TopSchedule: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/top/schedule/index.vue').default})
